(() => {
  if (window.ywCartUpsellInitialized) return;
  window.ywCartUpsellInitialized = true;


  
  const ywArrowLocks = new WeakSet();

document.addEventListener('click', (event) => {
  const arrow = event.target.closest('[data-yw-slide]');
  if (!arrow) return;

  event.preventDefault();

  const track = arrow.closest('.yw-upsell')
    ?.querySelector('.yw-upsell__track');

  if (!track || ywArrowLocks.has(track)) return;

  const card = track.querySelector('.yw-upsell__card');
  if (!card) return;

  const styles = getComputedStyle(track);
  const gap = parseFloat(styles.columnGap) || 0;
  const step = track.clientWidth;


  const maxScroll = Math.max(
    0,
    track.scrollWidth - track.clientWidth
  );

  const currentScroll = Math.max(
    0,
    Math.min(track.scrollLeft, maxScroll)
  );

  const targetScroll = Math.max(
    0,
    Math.min(
      currentScroll + Number(arrow.dataset.ywSlide) * step,
      maxScroll
    )
  );

  ywArrowLocks.add(track);

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  track.scrollTo({
    left: targetScroll,
    behavior: reduceMotion ? 'instant' : 'smooth',
  });

  setTimeout(() => {
    ywArrowLocks.delete(track);
  }, reduceMotion ? 50 : 450);
});




  function cleanUpsellModals() {
    const drawer = document.querySelector('cart-drawer');

    const openers = drawer
      ? [...drawer.querySelectorAll(
          'modal-opener[data-modal^="#YWCartQuickAdd-"]'
        )]
      : [];

    const expectedIds = new Set(
      openers.map((opener) => opener.dataset.modal.slice(1))
    );

    const modals = [...document.querySelectorAll(
      'quick-add-modal[id^="YWCartQuickAdd-"]'
    )];

    const newestById = new Map();

    modals.forEach((modal) => {
      const previous = newestById.get(modal.id);

      if (previous && !previous.hasAttribute('open')) {
        previous.remove();
      }

      newestById.set(modal.id, modal);
    });

    newestById.forEach((modal, id) => {
      if (!expectedIds.has(id) && !modal.hasAttribute('open')) {
        modal.remove();
      }
    });
  }

  let cleanupQueued = false;

  const observer = new MutationObserver(() => {
    if (cleanupQueued) return;
    cleanupQueued = true;

    requestAnimationFrame(() => {
      cleanupQueued = false;
      cleanUpsellModals();
    });
  });

 /*
observer.observe(document.body, {
  childList: true,
  subtree: true,
});
*/


  document.body.addEventListener('modalClosed', () => {
    setTimeout(() => {
      const drawer = document.querySelector('cart-drawer.active');
      if (!drawer) return;

      const anotherModal = document.querySelector(
        'modal-dialog[open], quick-add-modal[open]'
      );
      if (anotherModal) return;

      document.body.classList.add('overflow-hidden');

      const container = drawer.querySelector('#CartDrawer');
      const focusedElement = document.activeElement;

      const focusTarget = drawer.contains(focusedElement)
        ? focusedElement
        : drawer.querySelector('.drawer__close');

      if (container && typeof trapFocus === 'function') {
        trapFocus(container, focusTarget);
      }
    }, 0);
  });

  cleanUpsellModals();
})();
